/**
 * Used to sort an array of string.
 *
 * @returns {number}
 */
export default function stringCompare(a: string, b: string): number {
  return a.localeCompare(b, undefined, { numeric: true });
}
